import { Component, OnInit } from '@angular/core';
import { Employer } from '../../employer';
import { AuthService } from '../../auth.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { SharedService } from 'src/app/shared.service';
import {MatCheckboxModule} from '@angular/material/checkbox';

@Component({
  selector: 'app-employer-sign-up',
  templateUrl: './employer-sign-up.component.html',
  styleUrls: ['./employer-sign-up.component.css']
})
export class EmployerSignUpComponent implements OnInit {
  password = "";
  cnfPassword;
  employer_details: Employer = {
    role:'employer',
    profile:{
      first_name: '',
      last_name: '',
      email_id: '',
    }    
  }
  checker: boolean = false;

  constructor(private auth: AuthService, private router: Router, private _snackBar: MatSnackBar, private sharedService: SharedService) { }

  ngOnInit() {
  }

  onChange(event){
   this.employer_details.profile.first_name = String(this.employer_details.profile.first_name).trim().replace(/\s\s+/g, ' ');
   this.employer_details.profile.last_name = String(this.employer_details.profile.last_name).trim().replace(/\s\s+/g, ' ');
   this.employer_details.profile.email_id = String(this.employer_details.profile.email_id).trim().replace(/\s\s+/g, ' ');
  }
  

  onSubmit() {
    if(this.employer_details.profile.first_name && this.employer_details.profile.last_name && this.employer_details.profile.email_id){
      if (this.password === this.cnfPassword) {
        if(this.checker == true){
          this.auth.employerSignUp(this.employer_details.profile.email_id, this.password, this.employer_details).then(
            () => {
              localStorage.setItem('role', this.employer_details.role)
              localStorage.setItem('first_name', this.employer_details.profile.first_name);
              localStorage.setItem('last_name', this.employer_details.profile.last_name);
              localStorage.setItem('email_id', this.employer_details.profile.email_id);
              this.sharedService.updatedisplayName(this.employer_details.profile.first_name);
              // this.auth.employerSignUp(this.employer_details.profile.email_id ,this.password, this.employer_details).then((data)=>{
              //   console.log(data);
              //   localStorage.setItem('user',JSON.stringify(data));
                this.auth.sendMail(this.employer_details.profile.email_id).subscribe((a) => {
                  console.log("mail send")
                }, (error) => {
                  console.log(error)
                  console.log("mail not send")
                });
                this.router.navigate(['/employer-create-profile']);
            //   })
            } 
          ).catch(
            (error) => {
              console.log(error);
            }
          )
        } else{
            this._snackBar.open('Please accept T & C ', 'Okay', {
              duration: 5000,
            });
        }
      } else {
       // alert('Check confirm password');
        this._snackBar.open('Check confirm password', 'Okay', {
          duration: 5000,
        });
      }
    }else{
      this._snackBar.open('please fill all details', 'Okay', {
        duration: 5000,
      });
    }
  }

}
